/*角色管理 */
import { $http, buildHeaders } from "./index";

//获取角色列表
export const role_list = (params) => {
  return $http.get("/admin/AdminRole/index", { params });
};

//获取角色详情
export const role_detail = (id) => {
  return $http.get("/admin/AdminRole/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加角色
export const role_add = (data) => {
  return $http.post("/admin/AdminRole/add", data, {
    headers: buildHeaders(3),
  });
};

//修改角色
export const role_edit = (data) => {
  return $http.post("/admin/AdminRole/edit", data, {
    headers: buildHeaders(3),
  });
};

//角色启停
export const role_qt = (data) => {
  return $http.post("/admin/AdminRole/updateStatus", data, {
    headers: buildHeaders(3),
  });
};

//角色启停
export const role_auth = (data) => {
  return $http.post("/admin/AdminRole/auth", data, {
    headers: buildHeaders(3),
  });
};

//角色绑定用户
export const role_bind = (data) => {
  return $http.post("/admin/AdminRole/bindAdmin", data, {
    headers: buildHeaders(3),
  });
};

//删除角色
export const role_delete = (id) => {
  return $http.post(
    "/admin/AdminRole/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};
